export const SET_BASIC_PROPERTY = 'SET_BASIC_PROPERTY';